import React, { useEffect, useState } from "react";

import AntDTable from "../../AntDTable/AntDTable";

import { Card, DatePicker } from "antd";
import {
  getFormHistory,
} from "../../Helpers/API/CheckUpApi/FormApi";
import { formatDate } from "../../Helpers/Utilities/Common";
import { SeeAttachment } from "../../Radiology/SeeAttachment";
import { Col, Row } from "react-bootstrap";
const { RangePicker } = DatePicker;

export default function FormHistory({ patientId }) {
  const [showLoader, setShowLoader] = useState(false);
  const [data, setData] = useState([]);
  const [dateRange, setDateRange] = useState([]);

  // Function for handling the value of date range
  const onDateChange = (dateString) => {
    setDateRange(dateString);
  };

  // Function get form history API
  const fetchFormHistory = async () => {
    setShowLoader(true);
    const res = await getFormHistory({
      patient_id: patientId,
      date_from: dateRange.length > 0 ? dateRange[0] : "",
      date_to: dateRange.length > 1 ? dateRange[1] : "",
    });

    if (res.data) {
      var history = res.data.data.forms_history;
      var _parsed = history.map((form) => ({
        ...form,
        formatted_added_on: formatDate(form.added_on),
        attachment: (
          <SeeAttachment
            attachments={[
              { file_url: form.file_url, file_name: form.file_name },
            ]}
          />
        ),
      }));
      setData(_parsed);
    } else if (res.error) {
      setData([]);
    }

    setShowLoader(false);
  };

  useEffect(() => {
    fetchFormHistory();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateRange]);

  return (
    <Card className="card-with-table">
      <div className="card-table">
        <h5 className="font-bold">FORM HISTORY</h5>
        
        <div className="row">
          <div className="pl-0 mb-3 d-flex justify-content-start">
            <RangePicker onChange={onDateChange} />
          </div>
        </div>

        <AntDTable
          tableHeaders={["TYPE", "FORM", "GENERATED ON", "GENERATED BY"]}
          headerSelector={[
            "doc_type",
            "attachment",
            "formatted_added_on",
            "added_by_name",
          ]}
          tableData={data}
          loading={showLoader}
          scroll={{ x: true }}
          isClickable={false}
          searchExcluded={["attachment"]}
        />
      </div>
    </Card>
  );
}
